"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var contests_constants_1 = require("@biw/contests-constants");
var contests_core_1 = require("@biw/contests-core");
var EARNED_OVERRIDE_CODES = ['YNN', 'YYN', 'YNN', 'YYN', 'YNY', 'YYY'];
function getManagerFinalResultProps(state, program) {
    var programViewId = program.programViewId;
    var finalResult = contests_core_1.progress.selectors.getProgramViewFinalResults(state, programViewId);
    var finalResultCode = contests_core_1.progress.selectors.getResultCode(state, programViewId);
    var progressModel = contests_core_1.progress.selectors.getProgress(state, programViewId);
    var finalResultsCount = get_1.default(progressModel, 'finalResultsCount') || {
        total: 0,
        count: 0,
        percent: 0,
    };
    return tslib_1.__assign({ tileType: 'manager-final-result' }, finalResultsCount, { buttonTextCode: contests_constants_1.KEY_CODES.seeResults, totalNumberOfPoints: finalResult.totalNumberOfPoints || 0, mediaLabel: contests_core_1.client.selectors.getMediaLabel(state) || 'AwardPoints', earnedOverride: EARNED_OVERRIDE_CODES.indexOf(finalResultCode) !== -1 });
}
exports.default = getManagerFinalResultProps;
//# sourceMappingURL=final-result-props.js.map